import React from 'react';
import styled from '@emotion/styled';
import { layout } from '@modernhealth/vital-foundation';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import ExporeSeriesRow from '../components/ExploreSeriesRow';
import { YourCirclesRow } from '../components/YourCirclesRow';
import { FeaturedTopicsRow } from '../components/FeaturedTopicsRow';
import { CirclesBanner } from '../components/CirclesBanner';
import { CircleOnDemandRow } from '../components/CircleOnDemandRow';

const Wrapper = styled.div({
    width: '100%',
    maxWidth: layout.containerWidth,
    margin: '0 auto',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingTop: 48,
    paddingBottom: layout.footerHeight,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 48,
});

export const CirclesPage = () => {
    const { circlesShowOnDemand } = useFlags();
    const { t } = useTranslation('circles');

    return (
        <Wrapper>
            <CirclesBanner
                title={t('sections.banner.header')}
                description={t('sections.banner.description')}
                buttonTitle={t('sections.banner.cta.title')}
            />

            <YourCirclesRow />
            <FeaturedTopicsRow />
            {circlesShowOnDemand ? <CircleOnDemandRow /> : null}
            <ExporeSeriesRow />
        </Wrapper>
    );
};
